export const MIN_ID_INPUT_LENGTH = 4;
export const MAX_ID_INPUT_LENGTH = 20;

export const MIN_PASSWORD_INPUT_LENGTH = 8;
export const MAX_PASSWORD_INPUT_LENGTH = 15;

export const MIN_PHONE_NUMBER_INPUT_LENGTH = 10;
export const MAX_PHONE_NUMBER_INPUT_LENGTH = 11;
